import { render, staticRenderFns } from "./header-full.vue?vue&type=template&id=148ed8ed&scoped=true&"
import script from "./header-full.vue?vue&type=script&lang=js&"
export * from "./header-full.vue?vue&type=script&lang=js&"
import style0 from "./header-full.vue?vue&type=style&index=0&id=148ed8ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148ed8ed",
  null
  
)

export default component.exports